import { createClient, SupabaseClient } from '@supabase/supabase-js';

// TODO: Once database.ts is generated with real types via `npm run supabase:types`,
// uncomment the import below and add the generic: createClient<Database>(...)
// import type { Database } from '@/types/database';

// Required environment variables for Supabase
const REQUIRED_ENV_VARS = ['REACT_APP_SUPABASE_URL', 'REACT_APP_SUPABASE_ANON_KEY'] as const;

/**
 * Validates that all required Supabase environment variables are set.
 * Throws an error with details about which variables are missing.
 */
function validateSupabaseConfig(): void {
  const missingVars = REQUIRED_ENV_VARS.filter((varName) => !process.env[varName]);

  if (missingVars.length > 0) {
    const errorMessage = [
      'Supabase configuration error: Missing required environment variables:',
      ...missingVars.map((v) => `  - ${v}`),
      '',
      'Please ensure these variables are set in your .env.local file.',
      'See .env.example for reference.',
    ].join('\n');

    console.error(errorMessage);
    throw new Error(errorMessage);
  }
}

// Validate before initializing
validateSupabaseConfig();

// Supabase configuration from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

// Initialize Supabase client
let supabase: SupabaseClient;

try {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });
} catch (error) {
  const message = error instanceof Error ? error.message : 'Unknown Supabase init error';
  console.error('Failed to initialize Supabase:', message);
  throw new Error(`Supabase initialization failed: ${message}`, { cause: error });
}

export { supabase };
